import { Component, OnInit,ChangeDetectorRef } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SurveyService } from '../../service/survey.service';
import { ExcelService } from 'src/app/service/excel.service';

@Component({
  selector: 'app-reason-list-modal',
  templateUrl: './reason-list-modal.component.html',
  styleUrls: ['./reason-list-modal.component.scss']
})
export class ReasonListModalComponent implements OnInit {
  public reasonList:any = [];
  public CagsDeatails:any = [];
  public paymentStatus:any = [];
  public paymentStatusHeader:any = [];
  public ResponseStatus:any = [];
  public ResponseStatusHeader:any = [];

  constructor(
    public ngModal:NgbModal,
    public surveyService:SurveyService,
    private cd: ChangeDetectorRef,
    private excelService:ExcelService,
  ) { }

  ngOnInit(): void {
    if(this.surveyService.showReasonListModal){
      this.getReasonList();
    }

    if(this.surveyService.responseStatusModalOpen){
      this.getResponseStatusDetails(this.surveyService.responseDetails_rid)
    }

    if(this.surveyService.paymentStatusModalOpen){
      this.getPaymentStatusDetails(this.surveyService.responseDetails_rid)
    }

    if(Object.keys(this.surveyService.surveyCagsDeatils).length){
      this.cagSetter();
    }
  }

  cagSetter(){
    this.CagsDeatails = [];
    Object.keys(this.surveyService.surveyCagsDeatils).forEach((va:any) =>
    {
      let obj:any = {name:va,val:this.surveyService.surveyCagsDeatils[va]};
      this.CagsDeatails.push(obj);
    })
  }

  getReasonList(){
    this.surveyService.getReasonList()
    .subscribe({
      next: (res: any) => {
        if (res['status'] == 1) {
          this.reasonList = res['reasons'];
          this.cd.detectChanges();
        }
      },error :(e) =>{
        console.log(e)
      }
    })
  }

  getResponseStatusDetails(rid:any){
    this.surveyService.getResponseDetails(rid,'response')
    .subscribe({
      next: (res: any) => {
        if (res['status'] == 1) {
          this.ResponseStatus = res['result'];
          this.setResponseHeaders(this.ResponseStatus[0]);
          this.cd.detectChanges();
        }
      },error :(e:any) =>{
        console.log(e)
      }
    })
  }

  getPaymentStatusDetails(rid:any){
    this.surveyService.getResponseDetails(rid,'payment')
    .subscribe({
      next: (res: any) => {
        if (res['status'] == 1) {
          this.paymentStatus = res['result'];
          this.setPaymentHeaders(this.paymentStatus[0]);
          this.cd.detectChanges();
        }
      },error :(e:any) =>{
        console.log(e)
      }
    })
  }


  setResponseHeaders(obj:any){
    this.ResponseStatusHeader = [];
    Object.keys(obj).forEach((va:any) =>{
      let val = va;
      this.ResponseStatusHeader.push(val);
    })
    if(this.ResponseStatusHeader.length == 3){
      this.ResponseStatusHeader.push('reason');
    }
    // console.log(this.ResponseStatusHeader);
  }


  setPaymentHeaders(obj:any){
    this.paymentStatusHeader = [];
    Object.keys(obj).forEach((va:any) =>{
      let val = va;
      this.paymentStatusHeader.push(val);
    })
    if(this.paymentStatusHeader.length == 3){
      this.paymentStatusHeader.push('reason');
    }
  }

  



  downloadReasonList(){
    let downloadjson = this.reasonList.map((va:any,index:any) => ({'Sl No.':index+1,'Reasons':va.label,'Brief':va.brief,'cases':va.cases.join(',')}));
    this.excelService.exportJsonAsExcelFile(downloadjson,"Reasons-List");
  }
  

  reasonModalPopupClose(){
    this.resetAllModal();
    this.ngModal.dismissAll();
  }

  cagsDetailsPopupClose(){
    this.resetAllModal();
    this.ngModal.dismissAll();
  }

  resetAllModal(){
    this.surveyService.showCagsDeatilsModal = false;
    this.surveyService.showReasonListModal = false;
    this.surveyService.paymentStatusModalOpen = false;
    this.surveyService.responseStatusModalOpen = false;
  }

  SetGridColum(va:any){
    if(va == 'response'){
      return 'repeat(' + this.ResponseStatusHeader.length + ',' + 'minmax(150px,200px)' + ')';
    }
    return 'repeat(' + this.paymentStatusHeader.length + ',' + 'minmax(150px,200px)' + ')';
  }

}
